export const INVITE_INBOX_CHANGED = "fairshare:invite-inbox-changed";

export function notifyInviteInboxChanged() {
    window.dispatchEvent(new CustomEvent(INVITE_INBOX_CHANGED));
}
